import React from "react"
import {MosregSettingsForm} from "../views/MosregSettingsForm";
import {Loading} from "../../widgets/Loading";
import {connect} from "react-redux";
import {formActions} from "../../actions/FormActions";
import {settingsService} from "../../services/SettingsService";
import {settingsActions} from "../../actions/SettingsActions";
import Axios from "axios";
import {apiConstants} from "../../constants/ApiConstants";

class MosregSettingsFormContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: !!props.id,
            name: '',
            login: '',
            password: '',
            tax: 'no',
            cert: '',
            offerExpiredFlag: true,
            offerExpiredTime: 2,
            certs: [],
        };
        this.id = props.id;

        this.prefix = 'mo';
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        if (this.id) {
            const {dispatch} = this.props;
            dispatch(formActions.reset());

            settingsService.setPrefix(this.prefix).get(this.id, (data) => {
                this.setState({
                    isLoading: false,
                    name: data.Name,
                    login: data.Login,
                    password: data.Password,
                    tax: data.Tax !== "" ? data.Tax : 'no',
                    cert: data.UserCert,
                    offerExpiredFlag: data.offer_expired_flag ?? true,
                    offerExpiredTime: data.offer_expired_time ?? 2,
                    certs: data.Certs,
                })
            });
        } else {
            const token = localStorage.getItem('token');
            const config = {
                headers: {
                    'Authorization': 'bearer ' + token
                }
            };

            Axios.get(apiConstants.API_URL + '/cert', config).then((resp) => {
                const {data} = resp.data;
                this.setState({certs: data})
            });
        }
    }

    handleChange(e) {
        const name = e.target.name;
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        this.setState({[name]: value});
    }

    handleSubmit(e) {
        e.preventDefault();

        const { dispatch } = this.props;
        dispatch(formActions.loading());

        const params = new URLSearchParams();
        params.append('name', this.state.name);
        params.append('login', this.state.login);
        params.append('password', this.state.password);
        params.append('tax', this.state.tax);
        params.append('offer_expired_flag', this.state.offerExpiredFlag ? 'Y' : 'N');
        params.append('offer_expired_time', this.state.offerExpiredTime);
        params.append('cert', this.state.cert);

        if (this.id) {
            dispatch(settingsActions.update(this.id, params, this.prefix));
        } else {
            dispatch(settingsActions.add(params, this.prefix));
        }
    }

    render() {
        if (this.state.isLoading) {
            return (
              <Loading />
            );
        } else {
            return <MosregSettingsForm data={this.state} result={this.props.result} onChange={this.handleChange} onSubmit={this.handleSubmit} />
        }
    }
}

function mapStateToProps(store) {
    return {
        result: store.formReducer
    };
}

export default connect(mapStateToProps)(MosregSettingsFormContainer);
